<template>
  <div class="BoxAverbacoes">
    <div class="ResumoAverbacoes-container-item mb-3">
      <div 
        class="ResumoAverbacoes-container-item__title  d-flex d-inline justify-content-between">
        <div class="d-flex d-inline justify-content-between">
          <svg v-if="propAverbacao.origem && propAverbacao.origem === 'SOFIA_GED'"
               class="icon--sm gedIcon"
               role="presentation">
            <use :xlink:href="'#' + icons.gedIcon.id" />
          </svg>
          <div class="col-1">
            <p>{{ propAverbacao.data_averbacao | date }}</p>
          </div>
          <div class="col-3">
            <div class="form-group ml-3">
              <b-form-checkbox
                :id="`certidao_${propIndex}`"
                v-model="propAverbacao.averb_acrescida_certidao"
                switch
                :value="1"
                :checked="true"
                @change="changeSwitchAverbacao(propAverbacao)">
                Averbação acrescida na certidão
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-3">
            <div class="form-group">
              <b-form-checkbox
                :id="`livro_${propIndex}`"
                v-model="propAverbacao.averb_impressa_livro"
                switch
                :value="1"
                :checked="true"
                @change="changeSwitchAverbacao(propAverbacao)">
                Averbação impressa no livro
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-3">
            <div class="form-group">
              <b-form-checkbox
                v-if="!!propTransporte"
                :id="`transporte_${propIndex}`"
                v-model="propAverbacao.averb_impressa_transporte"
                switch
                :value="1"
                :checked="true"
                @change="changeSwitchAverbacao(propAverbacao)">
                Averbação impressa no transporte
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="text-right col-2">
          <button class="btn btn-sm btn-primary mr-2"
                  :disabled="propChange > 0"
                  @click="editarAverbacao(propAverbacao)">
            <svg class="ResumoAverbacoes-show_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + icons.edit.id" />
            </svg>
          </button>
          <button v-if="!propAverbacao.origem || (propAverbacao.origem && propAverbacao.origem !== 'SOFIA_GED')"
                  class="btn btn-sm btn-danger mr-2"
                  :disabled="propChange > 0"
                  @click="destroy(propAverbacao.documento_id)">
            <svg class="ResumoAverbacoes-show_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + icons.trash.id" />
            </svg>
          </button>
          <button class="btn btn-sm btn-primary"
                  :disabled="propChange > 0"
                  @click="imprimirAverbacao(propAverbacao)">
            <svg class="ResumoAverbacoes-show_icon icon--xxs"
                 role="presentation">
              <use :xlink:href="'#' + icons.printer.id" />
            </svg>
          </button>
        </div>
      </div>

      <div class="ResumoAverbacoes-container-item__content text-break"
           :class="{ 'mt-2': propAverbacao.origem && propAverbacao.origem === 'SOFIA_GED' }">
        {{ propAverbacao.texto_averbacao }}
      </div>
    </div>
  </div>
</template>

<script>
  /* assets */
  import plus from "@/assets/icons/add.svg?sprite"
  import note from "@/assets/icons/ICONS_todos/ICONS/note.svg?sprite"
  import edit from "@/assets/icons/SINOREG/edit.svg?sprite"
  import trash from '@/assets/icons/delete.svg?sprite'
  import printer from '@/assets/icons/print.svg?sprite'
  import gedIcon from '@/assets/icons/ged-temp.svg?sprite'

  export default {
    name: 'BoxAverbacao',
    props: {
      propAverbacao: { type: Object, default: () => ({})},
      propTransporte: { type: Object, default: () => ({})},
      propIndex: { type: Number, default: null},
      propFailupdate: {type: Boolean, default: null},
      propChange: {type: Number, default: 0}
    },
    data () {
      return {
        icons: { plus, note, trash, printer, edit, gedIcon }
      }
    },
    methods: {
      changeSwitchAverbacao (averb) {
        this.$emit('multiplaEdicaoAverbacao', averb)
      },
      editarAverbacao (averb) {
        this.$emit('editarAverbacao', averb)
      },
      destroy (documento_id) {
        this.$emit('destroyAverbacao', documento_id)
      },
      imprimirAverbacao (averb) {
        this.$emit('imprimirAverbacao', averb)
      }
    }
  }
</script>

<style lang="scss">
@import "../../../scss/_utilities/exports";

.ResumoAverbacoes {
	&-show {
		&_title {
			background-color: $sinoreg-blue;
			color: $color-white;
			font-size: pxToRem(22);
			font-weight: 500;
			padding: pxToRem(8);
		}

		&_title-label {
			font-size: pxToRem(22);
			font-weight: 500;
		}

		&_icon {
			fill: $color-white;
		}

		&_label {
			font-size: pxToRem(14);
		}

		&_sublabel {
			font-size: pxToRem(14);
			font-weight: 600;
		}

		&_header{
			&--grey{
				background-color: $sinoreg-card-gray;
				cursor: pointer;
				padding: pxToRem(10) pxToRem(20);
				color: $color-black;
				font-weight: 500;
				font-size: pxToRem(16);
			}

			&--blue{
				background-color: $color-light-blue;
				padding: pxToRem(10) pxToRem(20);
				color: $color-black;
				font-weight: 500;
				font-size: pxToRem(16);
			}

			&--shadow{
				box-shadow: 1px 2px pxToRem(7) $color-gray;
			}

			&--label{
				text-decoration: underline;
				font-size: pxToRem(13);
				margin-bottom: 0;
			}

			&--sublabel{
				font-size: pxToRem(13);
			}
		}

		&_vinculacao-header{
			font-size: pxToRem(12);
		}

		&_vinculacao-divider{
			border-top: 1px solid black;
		}

		&_hr{
			border-top: 1px solid $sinoreg-blue;
		}
	}
	&-addBox {
  	&__title {
			background-color: black;
			color: white;
		}
		&__content {
			padding: 10px;
      &--flag {
        padding: 25px 0 0 0;
      }
		}
	}

 	&-container {
     min-height: 250px;
		 &-item {
        &__title {}
        &__content {}
        border: solid grey 1px;
        padding: 5px;

        .btn {
          border-radius: 50%
        }
     }
 	}

	&.collapsed > .when-opened,
	:not(.collapsed) > .when-closed {
		display: none;
	}

	&.icons {

		&--black{
			fill: black;
		}
  }
}

.icon-done-averb {
  width: 20px;
  height: 20px;
}

.icon-close-averb {
  width: 20px;
  height: 20px;
}

.flag-averb {
  margin: 0px 30px 0px 30px;

  &-disabled {
    color: #c6c6c6;
    fill: #C6C6C6
  }
}

.iconBlue {
  fill: #074f7f;
  height: 1.3rem;
  width: 1.3rem;
  margin-bottom: 3px;
  margin-left: 6px;
}

.tooltipHelp::before,
.tooltipHelp::after {
  --scale: 0;
  --tooltip-color: #F9F9F9;
  --tooltip-color-border: rgba(0,0,0,.3);
  position: absolute;
  z-index: 1;
  content: '';
  bottom: -1rem;
  transition: 35ms;
  transform-origin: bottom center;
  transform: translateX(15%) translateY(44%) scale(var(--scale));
}

.tooltipHelp::before {
  content: attr(data-tooltip);
  padding: .5rem;
  width: 38%;
  color: black;
  border-radius: .7rem;
  word-wrap: break-word;
  background: var(--tooltip-color);
  box-shadow: inset 0 0 0.1em var(--tooltip-color-border);
  -webkit-filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
  filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
}

.tooltipHelp:hover::before,
.tooltipHelp:hover::after {
  --scale: 1;
}

.tooltipHelp:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border: solid;
  box-shadow: 0 10px 20px 10px;
  border-width: 0px 10px 20px 10px;
  transform: translateX(-100%) translateY(-240%) scale(var(--scale));
  border-color: transparent transparent var(--tooltip-color) transparent;
  -webkit-filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
  filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
}

.dataAverbacaoGed {
  display: contents;
}

.gedIcon {
  width: 47px;
  padding-bottom: 2px;
  margin-left: 25px;
}

.failUpdate {
  border: solid #ed0909 2px !important;
}
</style>
